"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convoTagsTool = void 0;
const zod_1 = require("zod");
exports.convoTagsTool = {
    name: 'convoTags',
    description: `This tool identifies conversation tags based on last user message. Call it when user message relates to available tags, BUT always continue with a normal conversational response afterward.
    Make sure user is directly referencing something that the available tags indicate before calling this tool.

    Available tags are provided in the system message as:
    <tool-data toolName="convoTags">
      <tool-data-entry key="tags">TAG_DETECTION_CONDITIONS</tool-data-entry>
    </tool-data>
    
    IMPORTANT: After calling this tool, you MUST continue with your normal conversational response to the user. The tool call is supplementary - not a replacement for responding.
    
    Examples:
    - If user says "witam" and you see tag "powitanie" → call with foundTags: ["powitanie"] AND respond normally (e.g., "Witam! Jak mogę Panu/Pani pomóc?")
    - If user says "chcę zarezerwować" and you see tag "rezerwacja" → call with foundTags: ["rezerwacja"] AND help with reservation
    
    This tool runs in background - always provide a helpful response to the user's message.
    `,
    zodSchema: zod_1.z.object({
        foundTags: zod_1.z.array(zod_1.z.string().describe("Exact tag name from tool-data entries (e.g. 'powitanie', 'rezerwacja')")).describe("Array of tag names that match the user message. Use the exact tag names from the tool-data entries.")
    }),
    blockStream: false
};
